<template>
  <div>
    <v-row class="mt-4" style="width: 100%">
      <v-col cols="1" class="sm-margin-top-25px">
        <div>
          <v-btn
            style="height: 38px"
            color="primary"
            block
            outlined
            @click="$router.push({ name: 'AdminNumber' })"
          >
            <v-icon left> mdi-arrow-left</v-icon>
            Back
          </v-btn>
        </div>
      </v-col>
    </v-row>
    <h1 class="mb-4 mt-4">Assignments</h1>
    <v-row>
      <v-col cols="12" class="pa-0 p-sm-3">
        <v-data-table
          :headers="headers"
          :items="items"
          :loading="loading"
          item-key="id"
          @update:options="getData"
        >
          <template
            v-for="header in headers"
            v-slot:[`item.${header.value}`]="{ value }"
          >
            <div :key="header.value">
              <div v-if="header.hasOwnProperty('formatter')">{{ header.formatter(value) }}</div>
              <template v-else>{{ value }}</template>
            </div>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import removeObjectEmptyValues from '../../utilities/removeObjectEmptyValues'
import { capitalizeFirstLetter } from '../../utilities/formatter'
import moment from 'moment'

export default {
  name: 'AdminAssignments',
  data: () => ({
    loading: false,
    headers: [
      {
        text: 'Number',
        align: 'start',
        sortable: false,
        value: 'number',
        class: ['text-caption', 'greyBuoyant'],
        cellClass: 'greyBuoyant'
      },
      {
        text: 'Start Time',
        align: 'start',
        sortable: false,
        value: 'start_time',
        class: ['text-caption', 'greyBuoyant'],
        formatter: (x) => x ? moment(x).format('YYYY-MM-DD HH:mm:ss') : '',
        cellClass: 'greyBuoyant'
      },
      {
        text: 'End Time',
        align: 'start',
        sortable: false,
        value: 'end_time',
        class: ['text-caption', 'greyBuoyant'],
        formatter: (x) => x ? moment(x).format('YYYY-MM-DD HH:mm:ss') : '',
        cellClass: 'greyBuoyant'
      }
    ],
    items: []
  }),
  methods: {
    ...mapActions('admin', ['getAdminAssignments']),
    ...mapActions(['showAlert']),
    capitalizeFirstLetter,
    async getData () {
      try {
        this.loading = true
        const payload = {
          uuid: this.$route.params.uuid
        }
        const data = await this.getAdminAssignments(payload)
        this.items = data
      } catch (err) {
        const error = (Array.isArray(err.message)) ? err.message[0] : err.message
        this.showAlert({ error })
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
<style scoped>
.mt-2px {
  margin-top: 2px;
}
.header-top {
  margin-bottom: 10px;
}
@media (max-width: 599px) {
  .sm-margin-top-25px {
    margin-top: -15px!important;
  }
}
</style>
